<template>
  <div class="selectbox">
    <div v-if="$root.cache.getOptions[input.id]">
      <div v-if="multiple">
        <multiselect v-model="model" :options="$root.cache.getOptions[input.id]" :multiple="multiple"
          :close-on-select="false" :clear-on-select="true" :preserve-search="true" placeholder="Seçiniz" label="label"
          :searchable="true" :custom-label="customLabel" :show-labels="false" track-by="label">
          <template #singleLabel="props">
            <span class="option__desc"><span class="option__title">{{ props.option.label }}</span></span></template>

          <template #tag="{ option, remove }">
            <span
              class="border rounded-lg px-2 text-xs block mb-1 divide-x justify-between items-center flex space-x-2"><span>{{
      option.label }}</span><span class="pl-1 py-1" @click="remove(option)"><svg xmlns="http://www.w3.org/2000/svg"
                  class="h-4  hover:text-red-400 text-gray-500 w-4" viewBox="0 0 24 24">
                  <path fill="currentColor"
                    d="m12 13.4l2.9 2.9q.275.275.7.275t.7-.275t.275-.7t-.275-.7L13.4 12l2.9-2.9q.275-.275.275-.7t-.275-.7t-.7-.275t-.7.275L12 10.6L9.1 7.7q-.275-.275-.7-.275t-.7.275t-.275.7t.275.7l2.9 2.9l-2.9 2.9q-.275.275-.275.7t.275.7t.7.275t.7-.275zm0 8.6q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22" />
                </svg></span></span>
          </template>
          <template #option="props">
            <div class="option__desc">
              <span class="option__title">{{ props.option.label }}</span>
              <span class="option__title" style="display:none">{{ normalize(props.option.label) }}</span>
            </div>
          </template>
        </multiselect>
        <span alt="Formdaki bütün değerleri seçer"
          class="global-button-xs cursor-pointer mt-2 flex block bg-white w-40 text-center" @click="selectAll">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="m10 16.4l-4-4L7.4 11l2.6 2.6L16.6 7L18 8.4z" />
          </svg>
          <span>Hepsini seç</span>
        </span>

      </div>
      <multiselect v-else v-model="model" :options="$root.cache.getOptions[input.id]" :multiple="false"
        :close-on-select="true" :clear-on-select="true" :preserve-search="true" :searchable="true"
        :custom-label="customLabel" placeholder="Seçiniz" label="label" :show-labels="false" track-by="label">
        <template #singleLabel="props">
          <span class="option__desc"><span class="option__title">{{ props.option.label }}</span></span></template>
        <template #option="props">
          <div class="option__desc">
            <span class="option__title">{{ props.option.label }}</span>
            <span class="option__title" style="display:none">{{ normalize(props.option.label) }}</span>
          </div>
        </template>
      </multiselect>
    </div>
    <template v-else>Yükleniyor</template>
  </div>
</template>
<script>
import multiselect from "vue-multiselect";
export default {
  // Eskiden "multipleSelect"ti (kopya); hata loglarında iki bileşen
  // birbirinden ayırt edilemiyordu.
  name: "selectBox",
  components: {
    multiselect,
  },
  data() {
    return {
      model: this.multiple == true ? [] : null,
      options: null,
      // Kayıtta olup seçenek listesinde artık bulunmayan değerler (silinmiş /
      // pasif seçenek). find() undefined döndüğü için model watcher'ı
      // "reading 'value'" ile çöküyordu. Ekranda gösterilemez ama kayıttan da
      // düşürülmez; yoksa kaydı açıp kaydetmek veriyi sessizce siler.
      unknownValues: [],
      valueApplied: false,
    };
  },
  props: ["input", "form", "value", "multiple"],

  created() {
    this.applyValue();
  },

  methods: {
    applyValue() {
      const options = this.$root.cache.getOptions[this.input.id];
      // Seçenekler henüz yüklenmediyse yüklendiğinde tekrar denenir.
      if (this.valueApplied || !this.value || !Array.isArray(options)) return;
      this.valueApplied = true;

      let items;
      if (Array.isArray(this.value)) {
        items = this.value;
      } else if (this.multiple == true) {
        items = String(this.value).split(",");
      } else {
        items = [this.value];
      }

      const found = [];
      const unknown = [];
      items
        .filter((item) => item !== "" && item != null)
        .forEach((item) => {
          const option = options.find((i) => i.value == item);
          if (option) found.push(option);
          else unknown.push(item);
        });
      this.unknownValues = unknown;
      this.model = this.multiple == true ? found : found[0] || null;
    },
    selectAll() {
      this.model = this.$root.cache.getOptions[this.input.id];
    },
    customLabel(option) {

      return option.label + " | " + this.normalize(option.label) + " | " + this.normaliz2(option.label);
    },
    normaliz2(text) {
    if(text){
      const map = {
        s: "ş",
        S: "Ş",
        u: "ü",
        U: "Ü",
        o: "ö",
        O: "Ö",
        i: "ı",
        I: "İ",
        c: "ç",
        C: "Ç",
        g: "ğ",
        G: "Ğ",
      };
      text = text.toLowerCase();
      return text.replace(/[suoiIcCgG]/g, function (char) {
        return map[char] || char;
      });
    }
    },

    normalize(text) {
      if(text){
      const map = {
        ş: "s",
        Ş: "S",
        ü: "u",
        Ü: "U",
        ö: "o",
        Ö: "O",
        ı: "i",
        İ: "I",
        ç: "c",
        Ç: "C",
        ğ: "g",
        Ğ: "G",
      };
      text = text.toLowerCase();
      return text.replace(/[\u015F\u015E\u00FC\u00DC\u00F6\u00D6\u0131\u0130\u00E7\u00C7\u011F\u011E]/g, function (char) {
        return map[char] || char;
      });
    }
    },
    customFilter(option, label, search) {
      const normalizedOption = this.normalize(label);
      const normalizedSearch = this.normalize(search);
      console.log(normalizedOption, normalizedSearch, "degerelr");
      return normalizedOption.includes(normalizedSearch);
    }
  },

  watch: {
    // Sadece ilk yüklemede seçenekler gelmemişse çalışır; sonraki yeniden
    // yüklemeler kullanıcının seçimini ezmez.
    "$root.cache.getOptions"() {
      this.applyValue();
    },
    form() {
      if (this.form) {
        this.unknownValues = [];
        this.model = null;
      }
    },
    model() {
      if (this.multiple == true) {
        const selected = (this.model || [])
          .filter((e) => e && e.value != null)
          .map((e) => e.value);
        this.$parent.$emit("changed", {
          name: this.input.name,
          value: selected.concat(this.unknownValues),
        });
      } else {
        // Kullanıcı yeni bir değer seçtiyse listede olmayan eski değer biter.
        // Seçim temizlenince (model null) eskiden burada çöküyordu.
        if (this.model) this.unknownValues = [];
        let value = null;
        if (this.model) value = this.model.value;
        else if (this.unknownValues.length) value = this.unknownValues[0];
        this.$parent.$emit("changed", {
          name: this.input.name,
          value,
        });
      }
    },
  },
};
</script>
